import {Card as AntCard} from 'antd';

import styles from './styles.module.scss';
import React from 'react';

export const Card = (props: React.ComponentProps<typeof AntCard>) => <AntCard className={styles.card} {...props} />;
